import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";



function Reviews() {
  return (
    <>
    <div className="reviews">
      <div className="reviewcont">
        <div className="review-style">
          <div className="reviey" >
            <h1>REVIEWS</h1>
          </div>
        </div>
      </div>
        <div className="brickdownchitown">
        <div className="brickup">
        <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>

         <h4>I have used D. A. Burns a number of times through the years.  They always arrive on time, do a great job, and are courteous and efficient.  Most recently Jason came and worked on upholstery stains and carpet cleaning.  All in a great experience!</h4>
        <p>M. M.</p>
        <p>Rogers Park, Chicago</p>
        </div>
        </div>
        </div>
        </>
  );
}

export default Reviews;
